<template>
    <div class="tabs_content" id="tab-2" v-if="entity">
        <section>
            <a
                v-if="isEditable"
                @click="_addCodec"
                class="tab_button tab_button_add"
                :title="$gettext('Přidat kodek')"
                v-translate>Přidat kodek</a>

            <h2 v-if="noSettings" v-translate>Nastavení není definováno.</h2>

            <PopupWithSelectbox
                @submitAction="_onPopupWithSelectActionSubmited"
            />

            <StreamProfileOrder v-for="(profiles, idCodec) in entity.stream_profile_order"
                :is-editable="isEditable"
                :id-codec="idCodec"
                :stream-pofile-ids="profiles"
                :codecs="codecs"
                :stream-profiles.sync="streamProfiles"
                @removeCodec="onRemoveCodec"
                @removeStreamProfile="onRemoveStreamProfile"
                @addStreamProfile="onAddStreamProfile"
                @sortStreamProfile="onSortStreamProfile"
                :key="'codec' + idCodec"
            />

        </section>
    </div>
</template>

<script>

import StreamProfileOrder from "./StreamProfileOrder";
import PopupWithSelectbox from "../../../common/PopupWithSelectbox";
import popupWithSelectboxMixin from "@/components/mixins/popup-with-selectbox"

export default {
    name: "DeviceTypeStreamProfiles",
    props: {
      entity: Object,
      streamProfiles: Array,
      codecs: Array,
      isEditable: Boolean,
    },
    mixins: [popupWithSelectboxMixin],
    components: {PopupWithSelectbox, StreamProfileOrder},
    methods: {
        _processDetailErrorMessage(error) {
            return this.processErrorMessage(error)
        },
        onRemoveCodec(idCodec) {
            delete this.entity['stream_profile_order'][idCodec];
            this.entity['stream_profile_order'] = {...this.entity['stream_profile_order']};
        },
        onRemoveStreamProfile(idCodec, deletedIdStreamProfile) {
            this.entity['stream_profile_order'][idCodec] = this.entity['stream_profile_order'][idCodec].filter((idStreamProfile) => idStreamProfile != deletedIdStreamProfile);
        },
        onAddStreamProfile(idCodec, newIdStreamProfile) {
            this.entity['stream_profile_order'][idCodec] = [...this.entity['stream_profile_order'][idCodec], newIdStreamProfile];
        },
        onSortStreamProfile(idCodec, newStreamProfileSortedIds) {
            this.entity['stream_profile_order'][idCodec] = newStreamProfileSortedIds;
        },
        _addCodec() {
            const usedCodecIds = Object.keys(this.entity.stream_profile_order).map(function(item) {
                return parseInt(item, 10);
            });

            const availableCodecs = this.codecs.filter((codec) => {
                return !usedCodecIds.includes(codec.id);
            });

            this.showPopupWithSelectbox("add-codec", this.$gettext("Vyberte kodek:"), this.$gettext("Přidat kodek"), availableCodecs);
        },
        _onPopupWithSelectActionSubmited(action, selectedValue, data) {
            if (action === "add-codec") {
                this._onCodecAdded(selectedValue);
            }
        },
        _onCodecAdded(idCodec) {
            const newStreamProfileOrder = {...this.entity.stream_profile_order};
            newStreamProfileOrder[idCodec] = [];

            this.entity.stream_profile_order = newStreamProfileOrder;
        }
    },
    computed: {
        noSettings() {
            let settingsNotDefined = true;

            try {
                settingsNotDefined = Object.keys(this.entity.stream_profile_order).length === 0;
            } catch (e) {
            }

            return settingsNotDefined;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/components/StreamProfiles.vue